export default "__VITE_ASSET__1082a86c__"